import React, { useState, useEffect } from 'react';
import LayoutHeader from './components/LayoutHeader';
import HomeHero from './components/HomeHero';
import EssenceSection from './components/EssenceSection';
import MenuSection from './components/MenuSection';
import AmbienceSection from './components/AmbienceSection';
import GallerySection from './components/GallerySection';
import ContactSection from './components/ContactSection';
import LayoutFooter from './components/LayoutFooter';
import { appTranslations } from './mock/translations';

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [translations, setTranslations] = useState(appTranslations.en);

  useEffect(() => {
    setTranslations(appTranslations[currentLanguage] || appTranslations.en);
  }, [currentLanguage]);

  const handleNavigate = (pageId) => {
    setCurrentPage(pageId);
    // Optional: Scroll to section if it's a single-page layout
    const section = document.getElementById(pageId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLanguageChange = (langCode) => {
    setCurrentLanguage(langCode);
  };

  return (
    <div className="bg-[#FFF8F0] font-sans antialiased">
      <LayoutHeader
        onNavigate={handleNavigate}
        onLanguageChange={handleLanguageChange}
        currentLanguage={currentLanguage}
        translations={translations}
      />

      <main>
        <section id="home" className="min-h-screen flex items-center justify-center">
          <HomeHero translations={translations} />
        </section>

        <section id="essence" className="min-h-screen flex items-center justify-center">
          <EssenceSection translations={translations} />
        </section>

        <section id="menu" className="min-h-screen flex items-center justify-center">
          <MenuSection translations={translations} />
        </section>

        <section id="ambience" className="min-h-screen flex items-center justify-center">
          <AmbienceSection translations={translations} />
        </section>

        <section id="gallery" className="min-h-screen flex items-center justify-center">
          <GallerySection translations={translations} />
        </section>

        <section id="contact" className="min-h-screen flex items-center justify-center">
          <ContactSection translations={translations} />
        </section>
      </main>

      <LayoutFooter translations={translations} />

      <style jsx global>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes zoomIn {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fade-in { animation: fadeIn 0.8s ease-out forwards; }
        .animate-fade-in-up { animation: fadeInUp 0.8s ease-out forwards; }
        .animate-slide-in-left { animation: slideInLeft 0.8s ease-out forwards; }
        .animate-slide-in-right { animation: slideInRight 0.8s ease-out forwards; }
        .animate-zoom-in { animation: zoomIn 0.8s ease-out forwards; }
        .animate-zoom-in-delay { animation: zoomIn 0.8s ease-out forwards; }
      `}</style>
    </div>
  );
};

export default App;